<div class="room-upgrade">
    <app-image-gallery1 [roomCode]="upgradeRoomCode" [hotelCode]="shopCart.items[0].searchParams.hotelCode"></app-image-gallery1>
    <div class="upgrade-texts">
        <h4>{{"pr.upgradeTitle"|translate}}</h4>
        <div class="upgrade-room-name">{{upgradeRoomName}}</div>
        <div class="upgrade-sales-pitch">{{salesPitch}}</div>
        <div class="upgrade-price">
            <span>{{"pr.Only"|translate}}</span>&nbsp;
            <span class="upgrade-price-amount" [innerHTML]="upgradePriceDifference|displayPrice"></span>&nbsp;
            <span>{{"pr.more"|translate}}</span>
        </div>
        <div class="upgrade-bottom">
            <p-button (click)="upgrade()">{{"pr.upgradeButton"|translate}}</p-button>
        </div>
        
    </div>
</div>
